package cc.bluepeak.clubmanager.site.pages

import androidx.compose.runtime.Composable
import cc.bluepeak.clubmanager.site.Res
import cc.bluepeak.clubmanager.site.components.layouts.PageLayoutData
import cc.bluepeak.clubmanager.site.components.widgets.Checkmark
import cc.bluepeak.clubmanager.site.components.widgets.FieldTag
import cc.bluepeak.clubmanager.site.components.widgets.LineTag
import cc.bluepeak.clubmanager.site.components.widgets.LiveDemo
import cc.bluepeak.clubmanager.site.styles.ButtonLinkVariant
import cc.bluepeak.clubmanager.site.styles.PaddedCardStyle
import cc.bluepeak.clubmanager.site.styles.SecondaryParagraph
import cc.bluepeak.clubmanager.site.styles.Theme
import com.varabyte.kobweb.compose.css.BackgroundPosition
import com.varabyte.kobweb.compose.css.BackgroundSize
import com.varabyte.kobweb.compose.css.CSSPosition
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@InitRoute
fun initSquadManagement(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(Res.string.squad_mgmt_tag, Res.string.squad_mgmt_title))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun SquadManagement() {
    Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(2.cssRem)) {
        Column(PaddedCardStyle.toModifier().fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {
            SimpleGrid(numColumns(1, md = 2), Modifier.gap(1.cssRem).fillMaxWidth()) {
                Column {
                    FieldTag(Res.string.squad_mgmt_tag)
                    H1 {
                        Text(Res.string.squad_mgmt_title)
                    }
                    P(
                        SecondaryParagraph.toModifier().margin(top = 1.cssRem, bottom = 2.cssRem)
                            .maxWidth(500.px).toAttrs()
                    ) {
                        Text(Res.string.squad_mgmt_desc)
                    }
                    Column(verticalArrangement = Arrangement.spacedBy(.5.cssRem)) {
                        Checkmark(Res.string.squad_mgmt_check_coaches)
                        Checkmark(Res.string.squad_mgmt_check_age)
                        Checkmark(Res.string.squad_mgmt_check_matches)
                    }
                }
                Image(
                    Res.image.team_celebrating, Modifier.borderRadius(Theme.shapes.medium)
                        .fillMaxWidth()
                        .maxHeight(360.px)
                        .objectFit(ObjectFit.Cover)
                )
            }

        }
        LiveDemo("team", Res.string.squad_mgmt_demo_cta, Res.string.squad_mgmt_demo_hint)
        Column(PaddedCardStyle.toModifier().fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(4.cssRem)) {
            SimpleGrid(numColumns(1, md = 2), Modifier.gap(1.cssRem).fillMaxWidth()) {
                Column {
                    FieldTag(Res.string.squad_mgmt_members_tag)
                    H1 {
                        Text(Res.string.squad_mgmt_members_title)
                    }
                    P(
                        SecondaryParagraph.toModifier().margin(top = 1.cssRem, bottom = 2.cssRem)
                            .maxWidth(500.px).toAttrs()
                    ) {
                        Text(Res.string.squad_mgmt_members_desc)
                    }
                    Link(Res.link.memberAdministration, Res.string.squad_mgmt_members_cta, variant = ButtonLinkVariant)
                }
                Image(
                    Res.image.members_connected_icon, Modifier.displayIfAtLeast(Breakpoint.MD)
                        .fillMaxWidth()
                        .maxHeight(280.px)
                        .objectFit(ObjectFit.Contain)
                )
            }
            SimpleGrid(numColumns(1, md = 2), Modifier.gap(1.cssRem).fillMaxWidth()) {
                Image(
                    Res.image.calendar_icon, Modifier.displayIfAtLeast(Breakpoint.MD)
                        .fillMaxWidth()
                        .maxHeight(280.px)
                        .objectFit(ObjectFit.Contain)
                )

                Column {
                    FieldTag(Res.string.squad_mgmt_calendar_tag)
                    H1 {
                        Text(Res.string.squad_mgmt_calendar_title)
                    }
                    P(
                        SecondaryParagraph.toModifier().margin(top = 1.cssRem, bottom = 2.cssRem)
                            .maxWidth(500.px).toAttrs()
                    ) {
                        Text(Res.string.squad_mgmt_calendar_desc)
                    }
                    Link(Res.link.calendar, Res.string.squad_mgmt_calendar_cta, variant = ButtonLinkVariant)
                }
            }
        }
        SimpleGrid(
            numColumns(1, 2), PaddedCardStyle.toModifier().fillMaxWidth()
                .gap(1.cssRem)
                .backgroundImage(url("""/${Res.string.locale}/${Res.image.fabric2}"""))
                .background {
                    size(BackgroundSize.Cover)
                    position(BackgroundPosition.of(CSSPosition.Center))
                }) {
            Column {
                LineTag(Res.string.squad_mgmt_cta_tag, Modifier.color(Theme.white))
                H1(Modifier.color(Theme.white).toAttrs()) {
                    Text(Res.string.squad_mgmt_cta_title)
                }
            }
            Column(PaddedCardStyle.toModifier()) {
                P(Modifier.margin(bottom = 1.cssRem).toAttrs()) {
                    Text(Res.string.squad_mgmt_cta_desc)
                }
                Link(Res.link.register, Res.string.squad_mgmt_cta_cta, variant = ButtonLinkVariant)
            }
        }

    }
}